import React from 'react';
import StatusBadge from '../../../components/StatusBadge';
import { ShotVersion } from '../../../types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface ShotVersionHeaderProps {
  version: ShotVersion;
  t: Translate;
  onDownload: () => void;
}

export default function ShotVersionHeader({ version, t, onDownload }: ShotVersionHeaderProps) {
  const handleDownload = (event: React.MouseEvent) => {
    event.stopPropagation();
    onDownload();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', marginBottom: '0.4rem' }}>
      <strong style={{ fontSize: '0.8rem' }}>v{version.version}</strong>
      {version.taskStatus && (
        <StatusBadge status={version.taskStatus} />
      )}
      <div style={{ flex: 1 }} />
      {version.taskStatus === 'completed' && version.videoURL && (
        <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center' }}>
          <button
            onClick={handleDownload}
            style={{ background: 'none', border: '1px solid var(--border)', borderRadius: '4px', cursor: 'pointer', padding: '2px 8px', fontSize: '0.75rem', color: 'var(--text-2)' }}
            title={t('version.downloadVideo')}
          >
            {t('version.downloadVideo')}
          </button>
        </div>
      )}
    </div>
  );
}
